import axios from "axios";

const url = process.env.REACT_APP_SERVER;

export const sessionLogin = async (id) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/sessionLogin`,
      data: {
        id,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getSessionLogin = async () => {
  try {
    const result = await axios.get(`${url}/loginsession`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const logoutApi = async () => {
  try {
    await axios.get(`${url}/logout`, {
      withCredentials: true,
    });
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const createOrganization = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/organization`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getOrgnaizations = async () => {
  try {
    const result = await axios.get(`${url}/api/organizations`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getSingleOrganization = async (id, corp_code) => {
  try {
    const result = await axios.get(
      `${url}/api/organization?id=${id || ""}&corporation_code=${
        corp_code || ""
      }`,
      {
        withCredentials: true,
      }
    );
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteSingleOrganization = async (id) => {
  try {
    const result = await axios.delete(
      `${url}/api/organization?id=${id || ""}`,
      {
        withCredentials: true,
      }
    );
    return result;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const updateOrganization = async (body) => {
  try {
    await axios({
      method: "PATCH",
      url: `${url}/api/organization`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

// CORPORATION

export const createCorporation = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/corporation`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const updateCorporation = async (body) => {
  try {
    await axios({
      method: "PATCH",
      url: `${url}/api/corporation`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getSingleCorporation = async (id) => {
  try {
    const result = await axios.get(`${url}/api/corporation?id=${id || ""}`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getCorporations = async () => {
  try {
    const result = await axios.get(`${url}/api/corporations`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getAllCorporationIds = async () => {
  try {
    const result = await axios.get(`${url}/api/corporations?id=${true}`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getAllOrgnaizationIds = async (id) => {
  try {
    const result = await axios.get(`${url}/api/organizations?id=${id}`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};
//  USER

export const createUser = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/user`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getSingleUser = async (id, corpId, orgId) => {
  try {
    const result = await axios.get(
      `${url}/api/user?id=${id || ""}&corporation_code=${
        corpId || ""
      }&organization_code=${orgId || ""}`,
      {
        withCredentials: true,
      }
    );
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getOrgUser = async (corpId, orgId) => {
  try {
    const result = await axios.get(
      `${url}/api/organization/user?corpId=${corpId || ""}&orgId=${
        orgId || ""
      }`,
      {
        withCredentials: true,
      }
    );
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteSingleUser = async (body) => {
  try {
    const result = await axios({
      method: "DELETE",
      url: `${url}/api/user`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const updateUser = async (body) => {
  try {
    await axios({
      method: "PATCH",
      url: `${url}/api/user`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getUsers = async (role) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/users`,
      data: {
        role,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const createProduct = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/product`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getProducts = async () => {
  try {
    const result = await axios.get(`${url}/api/products`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getSingleProduct = async (id) => {
  try {
    const result = await axios.get(`${url}/api/product?id=${id || ""}`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateProduct = async (body) => {
  try {
    await axios({
      method: "PATCH",
      url: `${url}/api/product`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const deleteSingleProduct = async (id) => {
  try {
    const result = await axios.delete(`${url}/api/product?id=${id || ""}`, {
      withCredentials: true,
    });
    return result;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getOrderBySku = async (sku, lot_no) => {
  try {
    const result = await axios.get(
      `${url}/api/order?sku=${sku}${lot_no ? `&lot_no=${lot_no}` : ""} `,
      {
        withCredentials: true,
      }
    );
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getOrderByLotNo = async (sku, lot_no) => {
  try {
    const result = await axios.get(
      `${url}/api/order/lot?sku=${sku}&lot_no=${lot_no}`,
      {
        withCredentials: true,
      }
    );
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};
export const getNoOfCorpOrg = async () => {
  try {
    const result = await axios.get(
      `${url}/api/corporations/organization/count`,
      {
        withCredentials: true,
      }
    );
    return result?.data?.data || {};
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getZipCode = async (zipcode) => {
  try {
    const result = await axios.get(`${url}/api/zipcode?zipcode=${zipcode}`, {
      withCredentials: true,
    });
    return result?.data || {};
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getAllProductsUnderCorp = async (corp_code) => {
  try {
    const result = await axios.get(
      `${url}/api/products/corp?corp_code=${corp_code || ""}`,
      {
        withCredentials: true,
      }
    );
    return result.data;
  } catch (err) {
    console.log("from catch", err);
    return false;
  }
};

export const getAllStoreIds = async (corpCode, orgCode) => {
  try {
    const result = await axios.get(
      `${url}/api/stores?corpCode=${corpCode || ""}&orgCode=${orgCode || ""}`,
      {
        withCredentials: true,
      }
    );
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getFilteredData = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/filters`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};
export const updateProductExpiryDate = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/update/product-expiry`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getAllActiveProducts = async () => {
  try {
    const result = await axios.get(`${url}/api/products/active`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log("from catch", err);
    return false;
  }
};

export const getAllExpiredProducts = async () => {
  try {
    const result = await axios.get(`${url}/api/products/expired`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log("from catch", err);
    return false;
  }
};

export const getAllProductsCount = async () => {
  try {
    const result = await axios.get(`${url}/api/products/count/bar-chart`, {
      withCredentials: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getPrimaryContactWithUID = async (uid) => {
  try {
    const result = await axios.get(`${url}/api/primary-contact?uid=${uid}`, {
      withCredentials: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getAllStores = async () => {
  try {
    const result = await axios.get(`${url}/api/all-stores`, {
      withCredentials: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const createSuperUser = async (body) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${url}/api/super-user`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getSuperUsers = async () => {
  try {
    const result = await axios.get(`${url}/api/super-users`, {
      withCredentials: true,
    });
    return result?.data?.data || [];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getSingleSuperUser = async (id) => {
  try {
    const result = await axios.get(`${url}/api/super-user?id=${id || ""}`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateSuperUser = async (body) => {
  try {
    await axios({
      method: "PATCH",
      url: `${url}/api/super-user`,
      data: {
        ...body,
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

// Configuration API Functions
export const getEscalationConfig = async () => {
  try {
    const result = await axios.get(`${url}/api/config/escalation`, {
      withCredentials: true,
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return {
      status: false,
      message: "Error fetching configuration"
    };
  }
};

export const updateEscalationConfig = async (data) => {
  try {
    const result = await axios({
      method: "PATCH",
      url: `${url}/api/config/escalation`,
      data: {
        escalation_threshold_days: data.escalation_threshold_days
      },
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return result.data;
  } catch (err) {
    console.log(err);
    return {
      status: false,
      message: "Error updating configuration"
    };
  }
};
